import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SocialMediaSection = () => {
  const [activeTab, setActiveTab] = useState('calendar');

  const contentCalendar = [
    {
      date: '2025-01-18',
      platform: 'Instagram',
      type: 'Carousel Post',
      content: 'Behind-the-scenes: Our design process',
      engagement: '+45%',
      status: 'scheduled'
    },
    {
      date: '2025-01-19',
      platform: 'LinkedIn',
      type: 'Article',
      content: 'Digital transformation trends for 2025',
      engagement: '+62%',
      status: 'published'
    },
    {
      date: '2025-01-20',
      platform: 'Facebook',
      type: 'Video',
      content: 'Client success story showcase',
      engagement: '+78%',
      status: 'draft'
    }
  ];

  const caseStudies = [
    {
      client: 'TechStart Solutions',
      industry: 'Technology',
      challenge: 'Low social media engagement',
      solution: 'Comprehensive content strategy + community management',
      results: {
        followers: '+285%',
        engagement: '+340%',
        leads: '+156%'
      },
      timeline: '3 months'
    },
    {
      client: 'Green Earth Co.',
      industry: 'Sustainability',
      challenge: 'Brand awareness in competitive market',
      solution: 'Influencer partnerships + targeted campaigns',
      results: {
        followers: '+420%',
        engagement: '+298%',
        leads: '+203%'
      },
      timeline: '4 months'
    }
  ];

  const platforms = [
    { name: 'Instagram', icon: 'Instagram', color: 'from-pink-500 to-purple-500' },
    { name: 'Facebook', icon: 'Facebook', color: 'from-blue-600 to-blue-700' },
    { name: 'LinkedIn', icon: 'Linkedin', color: 'from-blue-700 to-blue-800' },
    { name: 'Twitter', icon: 'Twitter', color: 'from-blue-400 to-blue-500' },
    { name: 'TikTok', icon: 'Music', color: 'from-black to-gray-800' },
    { name: 'YouTube', icon: 'Youtube', color: 'from-red-600 to-red-700' }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="Share2" size={16} />
            <span>Social Media Marketing</span>
          </div>
          <h2 className="text-3xl lg:text-5xl font-bold text-foreground mb-6">
            Strategic Social Media That Converts
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            We don't just post content—we build communities, spark conversations, and turn followers into loyal customers through data-driven strategies.
          </p>
        </div>

        {/* Interactive Demo Tabs */}
        <div className="mb-16">
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <button
              onClick={() => setActiveTab('calendar')}
              className={`px-6 py-3 rounded-lg font-semibold brand-transition ${
                activeTab === 'calendar' ?'bg-accent text-accent-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
            >
              Content Calendar
            </button>
            {/* <button
              onClick={() => setActiveTab('results')}
              className={`px-6 py-3 rounded-lg font-semibold brand-transition ${
                activeTab === 'results' ?'bg-accent text-accent-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
            >
              Client Results
            </button> */}
            <button
              onClick={() => setActiveTab('platforms')}
              className={`px-6 py-3 rounded-lg font-semibold brand-transition ${
                activeTab === 'platforms'
                  ? 'bg-accent text-accent-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
            >
              Platform Expertise
            </button>
          </div>

          {/* Content Calendar Tab */}
          {activeTab === 'calendar' && (
            <div className="bg-card rounded-2xl p-8 brand-shadow">
              <h3 className="text-2xl font-bold text-foreground mb-6">Live Content Calendar Tool</h3>
              <div className="space-y-4">
                {contentCalendar?.map((item, index) => (
                  <div key={index} className="flex items-center justify-between p-4 bg-surface rounded-lg">
                    <div className="flex items-center space-x-4">
                      <div className={`w-3 h-3 rounded-full ${
                        item?.status === 'published' ? 'bg-success' :
                        item?.status === 'scheduled' ? 'bg-warning' : 'bg-muted-foreground'
                      }`}></div>
                      <div>
                        <p className="font-semibold text-foreground">{item?.content}</p>
                        <p className="text-sm text-muted-foreground">{item?.platform} • {item?.type}</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-sm font-medium text-success">{item?.engagement}</p>
                      <p className="text-xs text-muted-foreground">{item?.date}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Client Results Tab */}
          {/* {activeTab === 'results' && (
            <div className="grid md:grid-cols-2 gap-8">
              {caseStudies?.map((study, index) => (
                <div key={index} className="bg-card rounded-2xl p-8 brand-shadow">
                  <div className="flex items-center justify-between mb-6">
                    <div>
                      <h3 className="text-xl font-bold text-foreground">{study?.client}</h3>
                      <p className="text-muted-foreground">{study?.industry}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-sm text-muted-foreground">Timeline</p>
                      <p className="font-semibold text-foreground">{study?.timeline}</p>
                    </div>
                  </div>
                  
                  <div className="mb-6">
                    <p className="text-sm text-muted-foreground mb-2">Challenge:</p>
                    <p className="text-foreground mb-4">{study?.challenge}</p>
                    <p className="text-sm text-muted-foreground mb-2">Solution:</p>
                    <p className="text-foreground">{study?.solution}</p>
                  </div>

                  <div className="grid grid-cols-3 gap-4">
                    <div className="text-center">
                      <p className="text-2xl font-bold text-success">{study?.results?.followers}</p>
                      <p className="text-xs text-muted-foreground">Followers</p>
                    </div>
                    <div className="text-center">
                      <p className="text-2xl font-bold text-accent">{study?.results?.engagement}</p>
                      <p className="text-xs text-muted-foreground">Engagement</p>
                    </div>
                    <div className="text-center">
                      <p className="text-2xl font-bold text-primary">{study?.results?.leads}</p>
                      <p className="text-xs text-muted-foreground">Leads</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )} */}

          {/* Platforms Tab */}
          {activeTab === 'platforms' && (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
              {platforms?.map((platform, index) => (
                <div key={index} className="text-center group">
                  <div className={`w-16 h-16 bg-gradient-to-r ${platform?.color} rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 brand-transition`}>
                    <Icon name={platform?.icon} size={32} className="text-white" />
                  </div>
                  <p className="font-semibold text-foreground">{platform?.name}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Process Steps */}
        <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-8 lg:p-12">
          <h3 className="text-2xl lg:text-3xl font-bold text-foreground text-center mb-12">
            Our Social Media Process
          </h3>
          
          <div className="grid md:grid-cols-5 gap-8">
            {[
              { step: '01', title: 'Discovery', desc: 'Audit current presence & competitor analysis' },
              { step: '02', title: 'Strategy', desc: 'Develop content strategy & posting schedule' },
              { step: '03', title: 'Creation', desc: 'Design engaging content & copy' },
              { step: '04', title: 'Launch', desc: 'Execute campaigns & community management' },
              { step: '05', title: 'Optimize', desc: 'Analyze performance & refine approach' }
            ]?.map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 bg-accent text-accent-foreground rounded-full flex items-center justify-center font-bold text-lg mx-auto mb-4">
                  {item?.step}
                </div>
                <h4 className="font-bold text-foreground mb-2">{item?.title}</h4>
                <p className="text-sm text-muted-foreground">{item?.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <Button 
            variant="default" 
            className="bg-accent hover:bg-accent/90 text-accent-foreground"
            iconName="Calendar"
            iconPosition="left"
          >
            Get Social Media Audit
          </Button>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaSection;